import { createContext, useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Eye } from "lucide-react";
import { usePreview, parseRecord } from "@/components/RecordPreview";
import { isStandalone } from "@/lib/device";

const Ctx = createContext({ dirty: false, setDirty: () => {} });
export const DirtyProvider = ({ children }) => { const [dirty, setDirty] = useState(false); return <Ctx.Provider value={{ dirty, setDirty }}>{children}</Ctx.Provider>; };
export const useDirty = () => useContext(Ctx);

export function OpenLink({ href, children, className, testId, onClick }) {
  const nav = useNavigate();
  if (isStandalone()) return <a href={href} data-testid={testId} className={className} onClick={(e) => { e.preventDefault(); onClick?.(e); nav(href); }}>{children}</a>;
  return <a href={href} target="_blank" rel="noreferrer" data-testid={testId} className={className} onClick={onClick}>{children}</a>;
}

export function SmartLink({ to, children, className = "", testId, onClick, ...rest }) {
  const preview = usePreview();
  const rec = parseRecord(to);
  if (rec) {
    return (
      <a href={to} target={isStandalone() ? undefined : "_blank"} rel="noreferrer" data-testid={testId} className={className || "inline-flex items-center gap-1"} title="Click to preview" {...rest}
        onClick={(e) => { if (!isStandalone() && (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1)) return; e.preventDefault(); e.stopPropagation(); onClick?.(e); setTimeout(() => preview(rec), 0); }}>
        {children}<Eye className="h-3.5 w-3.5 shrink-0 opacity-60 ml-1" data-testid={testId ? `${testId}-preview` : undefined} />
      </a>
    );
  }
  return <Link to={to} data-testid={testId} className={className} onClick={onClick} {...rest}>{children}</Link>;
}
